/** iOS 17+ / Safari-only Audio Session API; no-op elsewhere.
 *
 *  iOS routes "play-and-record" sessions toward the call receiver (quiet even
 *  at max volume) and "playback" sessions to the loudspeaker. We're only
 *  recording while a turn's mic is open, so we flip to play-and-record for the
 *  duration of the recording and back to playback for Elena's replies. */
export type AudioSessionType = "playback" | "play-and-record";

export function setAudioSessionType(type: AudioSessionType) {
  const audioSession = (navigator as { audioSession?: { type: string } }).audioSession;
  if (!audioSession) return;
  try {
    audioSession.type = type;
  } catch {
    /* unsupported value on this WebKit build */
  }
}
